module.exports = __webpack_public_path__ + "img/img-221.b4b5a762.png";